@if (isParentAuthLayout()) {
  <div class="parent-auth">
    <div class="parent-auth__shell">
      <aside class="parent-auth__hero">
        <div class="parent-auth__hero-glow" aria-hidden="true"></div>
        <div class="parent-auth__hero-inner">
          <img
            class="parent-auth__logo"
            src="/public/logos/logo.svg"
            alt="Valvur"
            width="120"
            height="40"
          />
          <h1 class="parent-auth__hero-title">
            {{ 'app.auth.title' | translate }}
          </h1>
          <p class="parent-auth__hero-subtitle">
            {{ 'app.auth.subTitle' | translate }}
          </p>
          <div class="parent-auth__hero-art" aria-hidden="true">
            <img src="/public/images/onboarding.png" alt="" />
          </div>
        </div>
      </aside>

      <section class="parent-auth__panel">
        <header class="parent-auth__panel-header">
          <h2 class="parent-auth__welcome">
            {{ 'app.auth.welcome' | translate }}
          </h2>
        </header>

        <nav class="parent-auth__segments" aria-label="Authentication mode">
          <app-toggle
            variant="parent"
            (selectedAuthFlow)="selectAuthFlow($event)"
          />
        </nav>

        <div class="parent-auth__forms">
          <mat-stepper linear #stepper>
            <mat-step>
              <app-signup-form
                [layout]="layout()"
                [requestPending]="isPending()"
                (formSubmitted)="handleSignup($event)"
              />
            </mat-step>
            <mat-step>
              <app-signin-form
                [layout]="layout()"
                [requestPending]="isPending()"
                (formSubmitted)="handleSignin($event)"
              />
            </mat-step>
          </mat-stepper>
        </div>
      </section>
    </div>
  </div>
} @else if (isStaffAuthLayout()) {
  <div
    class="staff-auth-page"
    [class.staff-auth-page--school]="isSchool()"
  >
    <div class="staff-auth-card">
      <header class="staff-auth-header">
        <img
          class="staff-auth-logo"
          src="/public/logos/logo_o.svg"
          alt="logo"
        />
        <p class="staff-auth-subtitle">
          {{ 'app.auth.welcomeSchool' | translate }}
        </p>
      </header>

      <section class="staff-auth-form">
        <app-signin-form
          [layout]="layout()"
          [requestPending]="isPending()"
          (formSubmitted)="handleSignin($event)"
        />
      </section>
    </div>
  </div>
}
